import { useGetApiCompaniesCurrentSubcompanies } from '@/api/generated/company-management-user/company-management-user'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/shadcn/select'

interface SubCompanySelectProps {
  value: number | null | undefined
  onChange: (id: number | null) => void
  disabled?: boolean
}

const NONE = '__none__'

export function SubCompanySelect({ value, onChange, disabled }: SubCompanySelectProps) {
  const { data } = useGetApiCompaniesCurrentSubcompanies()
  const subCompanies = data?.data ?? []

  return (
    <Select
      value={value != null ? String(value) : NONE}
      onValueChange={v => onChange(v === NONE ? null : Number(v))}
      disabled={disabled}
    >
      <SelectTrigger>
        <SelectValue placeholder="Tochterunternehmen auswählen" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={NONE}>Kein Tochterunternehmen</SelectItem>
        {subCompanies.map(sc => (
          <SelectItem key={sc.id} value={String(sc.id)}>
            {sc.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
